import Dexie from 'dexie';

export const db = new Dexie('InstallerDB');
db.version(1).stores({
  images: 'key, value', // Primary key and indexed props
  pendingInstalls: 'key, installation',
});
db.open();

//pendingInstalls: 'key, serialNum, url, pairingPhoto, platePic, primariesPhoto, prvPhoto, secondariesPhoto, unitPhoto',